// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__12yBt","infoBtn":"quickbooks_infoBtn__2C01L","formBox":"quickbooks_formBox__5P3fX","formFooter":"quickbooks_formFooter__1lzYL"};